import { render, staticRenderFns } from "./GroupedRadio.vue?vue&type=template&id=ad0228fa"
import script from "./GroupedRadio.vue?vue&type=script&lang=js"
export * from "./GroupedRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports